import { StyledModal } from '@app/components/modal/Modal';
import useChannelPartnerActions from '@app/hooks/channelPartners/useChannelPartnerActions';
import type { ChannelPartner } from '@app/services/api.types';
import type { ModalProps } from 'antd';

export type PartnerDeleteModalProps = ModalProps & {
    title?: string;
    data?: ChannelPartner;
};

export const PartnerDeleteModal = ({
    title = 'Delete Channel Partner?',
    data,
    ...props
}: PartnerDeleteModalProps) => {
    const { deleteChannelPartner } = useChannelPartnerActions();

    return (
        <StyledModal
            title={title}
            mask={{ closable: false }}
            okText="Delete"
            {...props}
            confirmLoading={deleteChannelPartner?.isPending}
            onOk={(e) => {
                const formData = { id: data?.id || 0 };
                deleteChannelPartner.mutate(formData, {
                    onSuccess: () => {
                        if (props?.onOk) {
                            props.onOk(e);
                        }
                    },
                });
            }}>
            <p>Are you sure you want to remove this channel partner?</p>
        </StyledModal>
    );
};

export default PartnerDeleteModal;
